import React from "react";
import "./styles.scss";
import { renderRichText } from "gatsby-source-contentful/rich-text";
import { Button, ButtonColour, ButtonSize } from "@trussle/external-components";
import { IContentfulHeroProps } from "../../types/IHero";
import { PanelWrapper } from "../PanelWrapper";
import { GatsbyImageOrSvg } from "../../utils/GatsbyImageOrSvg/GatsbyImageOrSvg";
import { TrustpilotPanel } from "../panels/TrustpilotPanel";
import { MultiStepForm } from "./form";
import LogoSVG from "../../images/better-logo.svg";
import { FormProvider } from "./form/context/FormContext";
import TrustBox from "../TrustBox";

export const HeroFF2: React.FC<IContentfulHeroProps> = ({
  heading1,
  bullets,
  imageFullWidth,
  showLogo
}) => (
  <PanelWrapper className="heroff2-panel-wrapper">
    {imageFullWidth && (
      <GatsbyImageOrSvg
        className="heroff2-bg-image"
        image={imageFullWidth}
        loading="lazy"
        alt={imageFullWidth.title}
      />
    )}
    <div className="heroff2-heading-container">
      {showLogo ? (
        <img
          src={LogoSVG}
          width={134}
          className="heroff2-logo"
          alt="better.co.uk logo"
          loading="lazy"
        />
      ) : null}
      <span className="heroff2-heading">{renderRichText(heading1!)}</span>
      <ul className="heroff2-list">
        {bullets?.map((bullet, index) => (
          <li key={index}>{bullet}</li>
        ))}
      </ul>
      <TrustBox className="heroff2-trustbox" />
      <Button
        className="heroff2-focus-button"
        size={ButtonSize.Large}
        colour={ButtonColour.DarkGreen}
        onClick={() => {
          window.location.hash = "get-started";
        }}
      >
        See my options
      </Button>
    </div>
    <div id="get-started" className="heroff2-form-container">
      <FormProvider>
        <MultiStepForm />
      </FormProvider>
    </div>
    <div className="heroff2-trustpilot-panel-container">
      <TrustpilotPanel headerAlignment="" />
    </div>
  </PanelWrapper>
);
